module.exports = __webpack_public_path__ + "img/ubc.f52df976.png";